import { TestType } from '@ab/ams-school-api/types/private/v1';
import { CustomizedDocumentTypesResource } from '@ab/ams-school-api/src/resources/customizedDocumentTypes';
import { DocumentProcessStatus } from '@ab/ams-school-api/src/services/studentDocuments/v1/types';
import { LanguageProficiencyData } from '@ab/ams-school-api/src/resources/applications/languageProficiency/types';
import { DeepStringifyDates } from '@ab/ams-school-backend-utils';

export type DocumentReviewStatus =
  | 'VERIFIED'
  | 'UNABLE_TO_VERIFY'
  | 'NO_RECORD_FOUND'
  | 'MANUALLY_ENTERED'
  | 'IDENTITY_MISMATCH';

export function isVerifyExamEnabled(
  customizedDocumentTypes: CustomizedDocumentTypesResource | undefined,
  testType: TestType | undefined
) {
  if (!customizedDocumentTypes) return false;
  const languageProficiencyType = customizedDocumentTypes.attributes.languageProficiencyTypes.find(
    (type) => type.type === testType
  );
  return languageProficiencyType?.verifyExamEnabled ?? false;
}

export function getDocumentReviewStatus(
  LanguageProficiencyData: DeepStringifyDates<LanguageProficiencyData>
): DocumentReviewStatus {
  const { overallScore, documentProcessingStatus, isAttachedToApplication } = LanguageProficiencyData;

  if (isAttachedToApplication) {
    return 'MANUALLY_ENTERED';
  } else if (
    LanguageProficiencyData.documentProcessingStatus === DocumentProcessStatus.EXAM_VERIFICATION_COMPLETED &&
    overallScore !== undefined
  ) {
    return 'VERIFIED';
  } else if (
    documentProcessingStatus === DocumentProcessStatus.UPLOADED_AI_SERVICE_UNAVAILABLE &&
    overallScore === undefined
  ) {
    return 'UNABLE_TO_VERIFY';
  } else if (
    documentProcessingStatus === DocumentProcessStatus.EXAM_VERIFICATION_FAILED &&
    overallScore === undefined
  ) {
    return 'NO_RECORD_FOUND';
  } else if (
    documentProcessingStatus === DocumentProcessStatus.EXAM_VERIFICATION_MISMATCH &&
    overallScore !== undefined
  ) {
    return 'IDENTITY_MISMATCH';
  }
  return 'NO_RECORD_FOUND';
}
